module.exports = __webpack_public_path__ + "7d8c00324967a3055c6710074267e908.svg";